import { MODULE } from "./consts";
import PurchasesDashboard from "./PurchasesDashboard";


export const PurchasesRoutes = [
  { path: `/${MODULE}`, exact: true, component: PurchasesDashboard },
];

export default PurchasesRoutes;
